import axios from 'axios';

import apiConfig from '@config/api.config';
import { APP_CONSTANTS } from '@constants/app.constants';
import { ROUTES } from '@constants/routes';
import { STORAGE_KEYS } from '@constants/storageKeys';
import { handleApiError } from '@services/api/errorHandler';
import useAuthStore from '@store/authStore';
import { storage } from '@utils/storage';

const axiosClient = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
  headers: apiConfig.headers,
  withCredentials: apiConfig.withCredentials,
});

axiosClient.interceptors.request.use(
  (config) => {
    const token = storage.get(STORAGE_KEYS.ACCESS_TOKEN);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const silent = Boolean(error?.config?.silent);
    const status = error?.response?.status;
    const skipAuthClear = Boolean(error?.config?.skipAuthClear);

    handleApiError(error, { silent });

    if (status === APP_CONSTANTS.HTTP_STATUS.UNAUTHORIZED && !skipAuthClear) {
      useAuthStore.getState().clearAuth();

      if (typeof window !== 'undefined' && window.location.pathname !== ROUTES.LOGIN) {
        window.location.assign(ROUTES.LOGIN);
      }
    }

    return Promise.reject(error);
  },
);

export const setAuthorizationHeader = (token) => {
  if (token) {
    axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axiosClient.defaults.headers.common.Authorization;
  }
};

export default axiosClient;
